import LinkCustomized from '@/components/shared/LinkCustomized'
import { INITIAL_LOCALE, INITIAL_LOCALES } from '@/libs/constants'
import { handleHrefChangeLocale } from '@/libs/functions'
import { LinkType, NavigationType } from '@/libs/types'
import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import HeaderSearch from '../../HeaderSearch'

interface LocaleLinkProps {
    locale: string
    item: string
    className?: string
    referrer?: string
}

const LinkedLocale: React.FC<LocaleLinkProps> = ({ item, className, locale, referrer }) => {
    const pathname = usePathname()

    return (
        <Link href={handleHrefChangeLocale(locale, item, pathname, referrer)}
            passHref
            className={clsx(className,
                "text-decoration-none",
                item === locale ? "disabled" : "cursor-pointer"
            )}>
            {item}
        </Link>
    )
}
interface ExtendedMobileProps {
    locale: string
    referrer?: string
    navigations: Array<NavigationType>
    handleClose: () => void
}

const ExtendedMobile: React.FunctionComponent<ExtendedMobileProps> = ({
    locale = "vi-VN",
    navigations,
    referrer,
    handleClose
}) => {

    const [toggleId, setToggleId] = React.useState<string | undefined>(undefined)

    const handleToggle = (name: string) => {
        if (name === toggleId) return setToggleId(undefined)
        setToggleId(name)
    }

    return (
        <>
            <div className="menu-mobile-extended bg-white p-3 h-100">
                <Container>
                    <Row>
                        {navigations.map(({ attributes: navigation }: NavigationType, index: number) => {
                            switch (navigation.type) {
                                case "linked":
                                    const linked: LinkType = navigation.linked[0]
                                    return (
                                        <Col xs={12} key={index}>
                                            <LinkCustomized
                                                locale={locale}
                                                className={clsx(linked.button ? 'btn-small' : '', navigation.classes, "fw-semi-bold sub-menu")}
                                                linked={linked}
                                                clicker={handleClose}
                                            />
                                            {index === 2 && (
                                                <>
                                                    <p className={clsx("fw-semi-bold sub-menu expanded mt-1 locale text-uppercase",
                                                        toggleId === navigation.name ? "open" : "")}
                                                        onClick={() => handleToggle("locales")}
                                                    >
                                                        {locale}
                                                    </p>
                                                    {toggleId === "locales" && INITIAL_LOCALES?.map((item: string, i: number) => {
                                                        return <LinkedLocale
                                                            key={i}
                                                            referrer={referrer}
                                                            item={item}
                                                            locale={locale}
                                                            className={"d-flex"}
                                                        />
                                                    })}
                                                </>
                                            )}
                                            {index === 2 && <HeaderSearch locale={locale}/>}
                                        </Col>
                                    )
                                case "menu":
                                    return (
                                        <Col xs={12} className={clsx(toggleId === navigation.name ? "mb-3" : "")} key={index}>
                                            <p className={clsx("fw-semi-bold sub-menu expanded", toggleId === navigation.name ? "open" : "")}
                                                onClick={() => handleToggle(navigation.name)}
                                            >{navigation.name}</p>
                                            {(toggleId === navigation.name) && navigation.linked.map((linked: LinkType) => {
                                                return (
                                                    <LinkCustomized
                                                        key={linked.id}
                                                        locale={locale}
                                                        className="mt-1 d-flex"
                                                        linked={linked}
                                                        clicker={handleClose}
                                                    />
                                                )
                                            })}
                                        </Col>
                                    )
                                case "extended":
                                    return (
                                        <Col xs={12} className={clsx(toggleId === navigation.name ? "mb-3" : "")} key={index}>
                                            <p className={clsx(navigation.classes,
                                                "fw-semi-bold sub-menu expanded",
                                                toggleId === navigation.name ? "open" : "")}
                                                onClick={() => handleToggle(navigation.name)}
                                            >{navigation.name}</p>
                                            {(toggleId === navigation.name) &&
                                                navigation.extended.map((item: any, index: number) => {
                                                    return (
                                                        <Col xs={12} className={clsx("mb-3", index !== 0 ? "py-2" : "")} key={index}>
                                                            <p className="fw-bold text-primary border-bottom">{item.name}</p>
                                                            {item.megamenu && item.megamenu.length !== 0 &&
                                                                <Row>
                                                                    {item.megamenu.map((menu: any, i: number) => {
                                                                        return (
                                                                            <Col key={i} xs={12}>
                                                                                <p className={clsx("fw-bold sub-menu", i !== 0 ? "mt-4" : "")}>{menu.name}</p>
                                                                                {menu.extended.map((linked: LinkType) => {
                                                                                    return (
                                                                                        <LinkCustomized
                                                                                            key={linked.id}
                                                                                            locale={locale}
                                                                                            className="mt-1 d-flex"
                                                                                            linked={linked}
                                                                                            clicker={handleClose}
                                                                                        />
                                                                                    )
                                                                                })}
                                                                            </Col>
                                                                        )
                                                                    })}
                                                                </Row>}
                                                            {item.items.map((linked: LinkType) => {
                                                                return (
                                                                    <LinkCustomized
                                                                        key={linked.id}
                                                                        locale={locale}
                                                                        className="mt-1"
                                                                        linked={linked}
                                                                        clicker={handleClose}
                                                                    />
                                                                )
                                                            })}
                                                        </Col>
                                                    )
                                                })}
                                        </Col>)
                                default: return null
                            }
                        })}
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ExtendedMobile